import { useEffect, useState } from "react";

/**
 * Live round chronometer anchored on snapshot round_elapsed_seconds.
 */
export function useKotRoundElapsedSeconds(kotSnapshot) {
  const roundState = kotSnapshot?.current_round?.round_state ?? null;
  const base = kotSnapshot?.round_timer?.round_elapsed_seconds;
  const active =
    roundState === "IN_PROGRESS" || roundState === "STOP_REQUESTED";

  const [elapsed, setElapsed] = useState(
    base != null ? Number(base) : 0
  );

  useEffect(() => {
    if (base == null || !active) {
      setElapsed(base != null ? Number(base) : 0);
      return undefined;
    }

    const anchorMs = Date.now() - Number(base) * 1000;
    const tick = () => {
      setElapsed(Math.max(0, Math.floor((Date.now() - anchorMs) / 1000)));
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [base, active]);

  return elapsed;
}

function useSmoothCountdownSeconds(base, isActive, isPaused, teId) {
  const [remaining, setRemaining] = useState(
    base != null && Number.isFinite(Number(base)) ? Number(base) : null
  );

  useEffect(() => {
    if (base == null || !Number.isFinite(Number(base))) {
      setRemaining(null);
      return undefined;
    }

    const baseVal = Math.max(0, Number(base));
    if (!isActive || isPaused) {
      setRemaining(baseVal);
      return undefined;
    }

    const endMs = Date.now() + baseVal * 1000;
    const tick = () => {
      setRemaining(Math.max(0, Math.ceil((endMs - Date.now()) / 1000)));
    };
    tick();
    const id = window.setInterval(tick, 250);
    return () => window.clearInterval(id);
  }, [base, isActive, isPaused, teId]);

  return remaining;
}

/**
 * Smooth exercise countdown between server timerUpdate ticks.
 */
export function useExerciseRemainingSeconds(exercise, isActive, isPaused) {
  return useSmoothCountdownSeconds(
    exercise?.timer,
    isActive,
    isPaused,
    exercise?.te_id
  );
}

/**
 * Smooth sequence countdown between server timerUpdate ticks.
 */
export function useSequenceRemainingSeconds(exercise, isActive, isPaused) {
  return useSmoothCountdownSeconds(
    exercise?.sequenceTimer,
    isActive,
    isPaused,
    exercise?.te_id
  );
}
